<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll" style="padding-top: 50px;">
            <ReviewNav :activeIndex="1"></ReviewNav>
            <div class="review-search bg-blue">
                <div class="review-search-item review-search-filter  div--inlineBlock" @click="showFilter(0)">
                    <img src="../../assets/review-filter.png">
                    <span class="">筛选</span>
                    <div class="redDot" v-if="shipName !== 'n' || countryName !== 'n'"></div>
                </div>
                <div class="review-search-item review-search-order div--inlineBlock" @click="showFilter(1)">
                    <img src="../../assets/review-seq.png">
                    <span class="">排序</span>
                    <div class="redDot" v-if="orderBy !== 0"></div>
                </div>
            </div>
            <TravelNoteFilter :isShow="isShowFilter"
                              :countries="countries"
                              :ships="ships"
                              :showType="showType"
                              :country="countryName"
                              :ship="shipName"
                              :order="orderBy"
                              @on-close="closeFilter"
                              @on-clear="clearFilter"
                              @on-confirm="confirmFilter"></TravelNoteFilter>

            <div class="list-container page-content bg-white">
                <div class="review-list bg-white">
                    <div class="review-list-tips border-grey">
                        <div v-html="home.reviewMobileTitle"></div>
                    </div>
                    <div class="review-list-content bg-white">
                        <div class="review-list-item" v-for="(item, itemIndex) in travelNotes" :key="item.id">
                            <router-link :to="`/Rccl.Review/Travel/d-${countryName}-${shipName}-${orderBy}-${itemIndex}-${item.id}.html`" class="external">
                                <div class="review-item-img">
                                    <img :src="item.iconImage">
                                </div>
                                <div class="review-item-text">
                                    <div class="review-item-wrapper">
                                        <div class="review-item-title">
                                            <div class="review-item-username div--inlineBlock">
                                                <img src="https://resource.rcclchina.com.cn/logo/MB/logoAvatarCircleBlueLarge.png">
                                                <span>{{item.author}}</span>
                                            </div>
                                            <div class="review-item-name div--inlineBlock">
                                                <div class="div--flex">{{item.title}}</div>
                                            </div>
                                            <div class="review-item-like div--inlineBlock">
                                                <img src="../../assets/review-like.png">
                                                <span>{{item.score}}</span>
                                            </div>
                                        </div>
                                        <div class="review-item-cruise">
                                            <div class="review-item-cruise-shipcode div--inlineBlock">{{item.shipName}}</div>
                                            <div class="review-item-cruise-cruisename div--inlineBlock">{{item.route}}</div>
                                            <div class="review-item-cruise-saildate div--inlineBlock">{{item.sailDate}}</div>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading" :identifier="thisIdentifier">
                        <span slot="no-more"></span>
                        <div class="review-list-tips" slot="no-results">
                            <p>抱歉，暂无搜索结果</p>
                            <a href="/Rccl.Review/Travel/TravelNotes" class="goToAll">查看全部游记</a>
                        </div>
                    </infinite-loading>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import ReviewNav from '@/components/Review/ReviewNav.vue'
    import InfiniteLoading from 'vue-infinite-loading'
    import TravelNoteFilter from '@/components/Review/TravelNoteFilter.vue'
    export default {
        name: 'TravelNotes',
        components: {
            ReviewNav,
            InfiniteLoading,
            TravelNoteFilter
        },
        data () {
            return {
                userToken: '',
                travelNotes: [],
                shipName: 'n',
                countryName: 'n',
                pageNum: 0,
                limit: 10,
                orderBy: 0, // 排序 0默认(出航时间) 1默认的倒序 5发布时间 6发布时间的倒叙 10点赞数 11点赞数的倒叙
                thisIdentifier: +Date.now(),
                countries: [],
                ships: [],
                home: {},
                isShowFilter: false,
                showType: 0, // 0 过滤  1 排序
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '游记攻略')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken
            },
            async infiniteHandler ($state) {
                this.$loading.show()
                const data = await this.getTravelNotes({
                    shipName: this.shipName == 'n' ? '': this.shipName,
                    countryName: this.countryName == 'n' ? '' : this.countryName,
                    offset: this.pageNum * this.limit,
                    limit: this.limit,
                    orderBy: this.orderBy
                })
                if (data.reviewArticleViews.length > 0) {
                    this.travelNotes = [...this.travelNotes, ...data.reviewArticleViews]
                    if (this.pageNum === 0) {
                        this.countries = data.countries
                        this.ships = data.ships
                        this.home = data.home
                    }
                    this.pageNum++
                    $state.loaded()
                } else {
                    $state.complete()
                }
                this.$loading.hide()
            },
            async getTravelNotes (requestData) {
                const {success, data, errMsg} = await api.review.getTravelNotes(requestData)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            showFilter (type) {
                this.isShowFilter = true
                this.showType = type
            },
            closeFilter () {
                this.isShowFilter = false
            },
            clearFilter () {
                this.countryName = ''
                this.shipName = ''
            },
            confirmFilter (filter) {
                this.pageNum = 0
                this.travelNotes = []
                this.countryName = filter.country || 'n'
                this.shipName = filter.ship || 'n'
                this.orderBy = filter.orderBy
                this.thisIdentifier = +Date.now()
                this.isShowFilter = false
            }
        }
    }
</script>

<style lang="less" scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }

    .review-search {
        height: 36px;
        font-size: 12px;
        color: white;
        line-height: 36px;
    }
    .review-search .redDot {
        position: absolute;
        left: 87px;
        top: 2px;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        background-color: #f00;
    }

    .review-search .review-search-item {
        width: 49.5%;
        text-align: center;
        position: relative;
    }

    .review-search .review-search-filter img {
        width: 15px;
        height: 20px;
        position: relative;
        top: 4px;
        margin-right: 8px;
    }
    .review-search .review-search-order img {
        width: 18px;
        height: 18px;
        position: relative;
        top: 4px;
        margin-right: 8px;
    }

    .review-search-ship {

    }

    .list-container {
        height: calc( 100vh - 55px - 44px - 36px);
    }

    .review-list-tips {
        min-height: 85px;
        font-size: 12px;
        margin: auto;
        position: relative;
        text-align: center;
    }

    .review-list-tips img {
        width: 100%;
        height: auto;
    }

    .review-list-tips a {
        display: block;
    }

    .review-list-tips p{
        font-size:12px;
        margin:0;
    }

    .review-list-content {
        border-top: 1px solid #eee;
        padding: 5px 10px;
        padding-bottom: 60px;
    }

    .review-list-content .review-list-item {
        position: relative;
        margin-bottom: 10px;
    }

    .review-list-item .review-item-img {
        width: 100%;
        height:172px;
        line-height: 0;
        overflow:hidden;
    }

    .review-list-item .review-item-img img {
        width: 100%;
    }

    .review-list-item .review-item-text {
        position: absolute;
        width: 100%;
        background-color: rgba(0,0,0, 0.5);
        bottom: 0px;
    }

    .review-list-item .review-item-text .review-item-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .review-list-item .review-item-title {
        border-bottom: 1px dotted #70706f;
        padding:6px 14px 7px 11px;
        overflow:hidden;
    }

    .review-list-item .review-item-username, .review-item-cruise-shipcode {
        width: 80px;
        font-size:0;
        display:inline-block;
    }

    .review-list-item .review-item-username img {
        width: 27px;
        height:27px;
        vertical-align:middle;
        margin-right:6px;
    }

    .review-list-item .review-item-username span {
        font-size: 13px;
        color: white;
        vertical-align:middle;
        display:inline-block;
        width:46px;
        word-break:break-word;
    }

    .review-list-item .review-item-name {
        width:172px;
        color: #f6b511;
        font-size: 12px;
        display:inline-block;
        text-align:center;
    }

    .review-list-item .review-item-name>div {
        font-size:13px;
        display:inline-block;
    }

    .review-list-item .review-item-like {
        width:66px;
        color: #f6b511;
        display:inline-block;
        font-size:0;
        text-align:right;
    }

    .review-list-item .review-item-like img {
        width: 27px;
        height:27px;
        vertical-align:middle;
        margin-right:4px;
    }

    .review-list-item .review-item-like span {
        vertical-align:middle;
        font-size:12px;
        color: #f6b511;
    }

    .review-item-cruise {
        clear: both;
        padding: 0px 14px 4px 11px;
        font-weight: bold;
    }
    .review-item-cruise-shipcode {
        color: white;
        text-align: left;
        font-size: 12px;
    }

    .review-item-cruise-cruisename {
        color: white;
        width: 172px;
        display:inline-block;
        font-size: 12px;
        text-align:center;
    }

    .review-item-cruise-saildate {
        width:72px;
        color: white;
        font-size: 12px;
        display:inline-block;
        text-align:center;
    }

    .recommend-content img {
        max-width: 100%;
        vertical-align: middle;
    }

    .white-box {
        margin-bottom: 10px;
        background-color: #fff;
        border-bottom: 1px solid #e2e2e2;
    }

    .line-title {
        position: relative;
        width: 350px;
        padding-top: 20px;
        padding-bottom: 15px;
        margin-left: auto;
        margin-right: auto;
        font-size: 13px;
        line-height: 1;
        color: #061556;
        font-weight: bold;
        text-align: center;
    }
    .line-title span {
        position: relative;
        z-index: 2;
        display: inline-block;
        padding: 0 10px;
        background-color: #fff;
    }
    .line-title::after {
        content: '';
        position: absolute;
        left: 0;
        top: 54%;
        display: block;
        width: 100%;
        height: 1px;
        background-color: #fab911;
    }


    .recommend {
        padding-bottom: 10px;
        margin-bottom: 44px;
    }
    .recommend-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 350px;
        margin-left: auto;
        margin-right: auto;
    }
    .recommend-box {
        width: 173px;
        margin-bottom: 10px;
    }
    .recommend-box-media {
        position: relative;
        height: 76px;
        font-size: 9px;
        line-height: 1;
        color: #fff;
        text-align: center;
        background-size: 100%;
    }
    .recommend-box-inner {
        height: 100%;
        padding-top: 14px;
        background-color: rgba(0,0,0,.4);
    }
    .recommend-box-media .longLine {
        position: absolute;
        top: 0;
        right: 5px;
        width: 48px;
    }
    .recommend-box-media .longLine-txt {
        position: absolute;
        left: -25%;
        top: -1px;
        width: 150%;
        font-size: 13px;
        color: #fff;
        text-align: center;
    }
    .recommend-box-media .longLine-txt span {
        display: block;
        -webkit-transform: scale(.6);
        transform: scale(.6);
    }
    .recommend-box-media p {
        margin: 0 0 3px 0;
    }
    .recommend-box-media .txt01 {
        font-weight: bold;
    }
    .recommend-box-media .txt02 {
        font-size: 12px;
        font-weight: bold;
    }
    .recommend-box-btn {
        height: 27px;
        background: #fab911;
        font-size: 13px;
        line-height: 27px;
        color: #000d57;
        text-align: center;
    }

    .mGuide-header {
        display:flex;
        align-items:center;
        justify-content:space-between;
        width:350px;
        height:40px;
        margin-left:auto;
        margin-right:auto;
        padding-left:15px;
        padding-right:15px;
    }
    .mGuide-header-txt {
        font-size: 13px;
        color: #061556;
        line-height:17px;
        font-weight:bold;
    }
    .mGuide-header-arrow {
        width: 8px;
        height: 8px;
        -webkit-transform: rotateZ(-45deg);
        transform: rotateZ(-45deg);
        border-right: 1px solid #fab911;
        border-bottom: 1px solid #fab911;
    }
    .mGuide-header.active .mGuide-header-arrow {
        -webkit-transform: rotateZ(45deg);
        transform: rotateZ(45deg);
    }

    .travelGuide {
        border-top: 1px solid #dddddd;
    }

    .strategy {
        padding-bottom:20px;
        border-top: 1px solid #dddddd;
    }
    .strategy .mGuide-header {
        border-bottom: 1px solid #dddddd;
    }
    .strategy-row {
        display: flex;
        width: 350px;
        margin-left: auto;
        margin-right: auto;
        padding: 10px 10px 10px 5px;
        border-bottom: 1px solid #dddddd;
    }
    .strategy-row-arrow {
        flex:none;
        position: relative;
        width:21px;
        height: 21px;
        background-color: #fab911;
        border-radius:50%;
        opacity:0;
    }
    .strategy-row-arrow::after {
        content: '';
        position: absolute;
        left: 4px;
        top: 6px;
        display: block;
        width: 8px;
        height: 8px;
        -webkit-transform: rotateZ(-45deg);
        transform: rotateZ(-45deg);
        border-right: 1px solid #fff;
        border-bottom: 1px solid #fff;
    }
    .strategy-row.active .strategy-row-arrow::after {
        left: 6px;
        top: 5px;
        -webkit-transform: rotateZ(45deg);
        transform: rotateZ(45deg);
    }
    .strategy-row-media {
        flex: none;
        display: block;
        width: 21px;
        height:22px;
    }
    .strategy-row-media img {
        max-width:100%;
    }
    .strategy-row-inner {
        position:relative;
        flex:1;
        width:293px;
        padding-top:3px;
        padding-left:6px;
        padding-right:8px;
        font-size:11px;
        color:#333;
        line-height:17px;
    }
    .strategy-row-inner p {
        display:inline-block;
        margin:0;
    }
    .strategy-row-inner .inner1 {
        width:100%;
        height: 18px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .strategy-row-inner .inner2 {
        display:none;
    }
    .strategy-row.active .inner1 {
        display:none;
    }
    .strategy-row.active .inner2 {
        display: block;
    }
    .strategy-row-inner .bold {
        font-weight: bold;
    }

    .goToAll {
        margin: 10px auto;
        display: block;
        border: solid 1px #0073bb;
        width: 96px;
    }
</style>
